$(document).ready(function () {
        $(".carousel").slick({
          arrows: true,
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: false,
              },
            },
          ],
        });
      });


document.addEventListener('DOMContentLoaded', function() {
  const accordionBoxes = document.querySelectorAll('.accordion .box');
  
  accordionBoxes.forEach(box => {
    const question = box.querySelector('.q');
    const answer = box.querySelector('.a');
    const plusImg = box.querySelector('.plus');
    const minusImg = box.querySelector('.minus');
    
    // 回答パネルの実際の高さを取得する関数
    const getFullHeight = () => {
      const prevMaxHeight = answer.style.maxHeight;
      answer.style.maxHeight = 'none';
      const fullHeight = answer.scrollHeight;
      answer.style.maxHeight = prevMaxHeight;
      return fullHeight;
    };

    // 画像の表示/非表示を切り替える関数
    const toggleImages = (isOpen) => {
      if (isOpen) {
        plusImg.style.display = 'none';
        minusImg.style.display = 'inline';
      } else {
        plusImg.style.display = 'inline';
        minusImg.style.display = 'none';
      }
    };

    question.addEventListener('click', () => {
      const isOpen = box.classList.contains('opened');
      
      if (isOpen) {
        // 閉じる
        box.classList.remove('opened');
        answer.style.maxHeight = '0px';
        toggleImages(false);
      } else {
        // 開く
        box.classList.add('opened');
        // 現在のスクロール高さを取得して直接設定
        answer.style.maxHeight = answer.scrollHeight + 'px';
        toggleImages(true);
      }
    });

    // 初期状態の画像表示を設定
    toggleImages(box.classList.contains('opened'));
  });

  // コンテンツの高さが動的に変更される可能性がある場合の処理
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const openedAnswers = document.querySelectorAll('.accordion .box.opened .a');
      openedAnswers.forEach(answer => {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      });
    }, 100);
  });
});